import { useEffect, useState } from "react";
import { baseAPI } from "../../Services/baseApi";
import Table from "./Components/Table";
import { useNavigate } from "react-router-dom";
import CommonModal from "../../Components/CommonModal";

const AllWinners = () => {
  const navigate = useNavigate();
  const [winners, setWinners] = useState({
    isLoading: true,
    data: [],
    error: false,
  });

  console.log(winners.data)

  const [modal, setModal] = useState(false);
  const [id, setId] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    baseAPI
      .get("winners/allwinners")
      .then((res) => {
        setWinners({
          isLoading: false,
          data: res.data,
          error: false,
        });
      })
      .catch((err) => {
        setWinners({
          isLoading: false,
          data: [],
          error: true,
        });
      });
  }, []);

  const handleClick = (id) => {
    navigate(`/winners/${id}`);
  };

  const handlemodal = (id) => {
    setModal(true);
    setId(id);
    setSuccess(false);
  };

  const handleDelete = (id) => {
    baseAPI
      .delete(`winners/delete/${id}`)
      .then((res) => {
        setSuccess(true);
        setWinners({
          ...winners,
          data: winners.data.filter((item) => item.id !== id),
        });
        setTimeout(() => {
          setModal(false);
        }, 2000);
      })
      .catch((err) => {
        alert(err);
      });
  };

  if (winners.isLoading) {
    return (
      <div className="h-screen flex justify-center items-center">
        <h1>Loading...</h1>
      </div>
    );
  }
  if (winners.error) {
    return (
      <div className="h-screen flex justify-center items-center">
        <h1>Error Loading Winners</h1>
      </div>
    );
  }

  return (
    <main className="w-full min-h-screen bg-neutral-100 flex  ">
      <Table
        winners={winners.data}
        handleClick={handleClick}
        handleModal={handlemodal}
      />

      {modal && (
        <CommonModal
          success={success}
          handleSubmit={() => handleDelete(id)}
          setModal={setModal}
          successText=" პროექტი წარმატებით წაიშალა!!"
          question=" პროექტი ხართ რომ გინდათ სიახლის წაშლა?"
        />
      )}
    </main>
  );
};

export default AllWinners;